import { AnyDocument } from '../../../types';
import { InceptHeader } from '../../constants/InceptHeader';
import { ConstructPost } from '../../types/ConstructPost';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';

type CreateRootDocumentResponse = {
  data: AnyDocument;
  meta: { currentPlace: string };
};

export const postCreateRootDocument = (
  constructPost: ConstructPost,
  definitionName: string,
  workflowName: string,
): Promise<CreateRootDocumentResponse | undefined> =>
  constructPost<CreateRootDocumentResponse>(
    DOCUMENTS_BASE_PATH,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.WorkflowName]: workflowName,
      },
    },
    { preventDefaultErrorToast: true },
  );
